module.exports = __webpack_public_path__ + "img/arrow-narrow-up.3aa3e6ed.svg";